// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"b99c2ec0","213":"9250aa2f","280":"818b3142","355":"d18affb5","399":"a3a33da5","688":"b82d7823","732":"6c1570b3","770":"e6085680"}[chunkId] + ".chunk.js";
};